import * as React from "react";
import * as store from "../../framework/customStore";
import * as storeTypes from "../../models/store/storeTypes";
import * as storeActions from "../../models/store/storeActions";
import { Base } from "ui/Scripts/source/framework/base";
import { SaveDataObj } from "../../framework/saveData";
import { customHistory } from "../../framework/customHistory";
import * as instantMessageChannelService from "../../models/services/instantMessageChannelService";
import { Translations } from "ui/Scripts/source/models/translations";
import { EditPageHeader } from "../app/header";
import { IEndlessList } from "ui/Scripts/source/models/common/endlessList";
import { InstantMessageChannelHelper } from "ui/Scripts/source/models/instantMessage/instantMessageChannelHelper";
import { IInstantMessageChannelEdit, InstantMessageChannelEdit } from "ui/Scripts/source/models/instantMessage/instantMessageChannelEdit";
import { AppUtils } from "../../framework/appUtils";
import { IUserState } from "../../models/store/storeTypes";
import { FileAttachment, IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { INumberTitle, NumberTitle } from "ui/Scripts/source/models/common/numberTitle";
import { IInstantMessageChannelEditUserItem, InstantMessageChannelEditUserItem } from "ui/Scripts/source/models/instantMessage/instantMessageChannelUserEditItem";
import { IInstantMessageChannelAddedUser } from "ui/Scripts/source/models/instantMessage/instantMessageChannelAddedUser";
import { IUserListItem, UserListItem } from "../../models/user/userListItem";
import { AvatarImage } from "ui/Scripts/source/components/framework/avatarImage";
import { InstantMessageChannelUserList } from "./instantMessageChannelUserList";
import { EnumHelper, InstantMessageChannelArchivingType, InstantMessageChannelMessageExpirationTime, InstantMessageChannelUserType } from "ui/Scripts/source/models/enums";
import { CheckBox } from "ui/Scripts/source/components/framework/checkbox";
import { RouteComponentProps } from "react-router-dom";
import { Radio } from "ui/Scripts/source/components/framework/radio";
import { SaveAttachmentBase64 } from "../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/common/saveAttachmentBase64";
import { Footer } from "../app/footer";

export interface IInstantMessageChannelEditViewOwnProps {
}

export interface IInstantMessageChannelEditViewStateProps {
    user: IUserState;
    isLoading: boolean;
    item: IInstantMessageChannelEdit;
    returnUrl: string;
}

export interface IInstantMessageChannelEditViewDispatchProps {
    loadInstantMessageChannelEdit: (id: string) => void;
    resetInstantMessageChannelEdit: () => void;
}

export interface IInstantMessageChannelEditViewPathProps {
    instantMessageChannelId: string;
}

type InstantMessageChannelEditViewProp = IInstantMessageChannelEditViewOwnProps & IInstantMessageChannelEditViewStateProps & IInstantMessageChannelEditViewDispatchProps & RouteComponentProps<IInstantMessageChannelEditViewPathProps>;

export interface IInstantMessageChannelSaveState {
    id: string;
    companyId: string;
    code: string;
    file: IFileAttachment,
    resetPicture: boolean;
    internalChannel: boolean;
    activeState: number;
    archivingType: number;
    archivingRemoveDate: string;
    comment: string;
    messageExpirationTime: number;
    rowId: string;
}

interface IInstantMessageChannelEditViewState extends IInstantMessageChannelSaveState {
    defaultArchivingRemoveDate: string;
    // General
    messageExpirationTimes: INumberTitle[];
    picture: string;
    // Users
    channelUsers: IInstantMessageChannelEditUserItem[];
}

export class InstantMessageChannelEditView extends React.Component<InstantMessageChannelEditViewProp, IInstantMessageChannelEditViewState> {
    private static orgStateHash: string = "";
    private dataContainerDiv: HTMLDivElement;
    private scrollToTop: boolean;

    private static getStateFromProps = (props: InstantMessageChannelEditViewProp): IInstantMessageChannelEditViewState => {
        let editItem = props.item;
        if (!editItem) {
            editItem = new InstantMessageChannelEdit();
        }
        const item = editItem.instantMessageChannel;
        const result: IInstantMessageChannelEditViewState = {
            // General
            messageExpirationTimes: [
                NumberTitle.createNumberTitle(InstantMessageChannelMessageExpirationTime.Quarter, "3 " + Translations.Months),
                NumberTitle.createNumberTitle(InstantMessageChannelMessageExpirationTime.HalfYear, "6 " + Translations.Months),
                NumberTitle.createNumberTitle(InstantMessageChannelMessageExpirationTime.Year, "12 " + Translations.Months),
                NumberTitle.createNumberTitle(InstantMessageChannelMessageExpirationTime.None, Translations.Unlimited)
            ],
            companyId: item.companyId,
            id: item.id,
            code: item.code,
            file: null,
            picture: item.picture,
            resetPicture: false,
            comment: item.comment,
            messageExpirationTime: item.messageExpirationTime,
            internalChannel: item.internalChannel,
            activeState: item.activeState,
            archivingType: item.archivingType,
            archivingRemoveDate: Base.timeToDateStr(item.archivingRemoveDate ? item.archivingRemoveDate : editItem.archivingRemoveDate),
            defaultArchivingRemoveDate: Base.timeToDateStr(editItem.archivingRemoveDate),
            rowId: item.rowId,
            // Users
            channelUsers: editItem.users.slice(0)
        };
        if (!Base.isNullOrEmpty(item.id)) {
            InstantMessageChannelEditView.getSaveDataFromState(result)
                .then(saveData => {
                    InstantMessageChannelEditView.orgStateHash = saveData.hash;
                });
        } else {
            InstantMessageChannelEditView.orgStateHash = "";
        }
        return result;
    };

    constructor(props: InstantMessageChannelEditViewProp) {
        super(props);
        this.scrollToTop = false;
        this.state = InstantMessageChannelEditView.getStateFromProps(props);
    }

    static getDerivedStateFromProps(nextProps: InstantMessageChannelEditViewProp, prevState: IInstantMessageChannelEditViewState): IInstantMessageChannelEditViewState {
        const intantmessageChannelId = nextProps.item?.instantMessageChannel?.id ?? "";
        if (!prevState.id || (intantmessageChannelId !== prevState.id)) {
            return InstantMessageChannelEditView.getStateFromProps(nextProps);
        } else {
            return null;
        }
    }

    componentDidMount(): void {
        this.props.loadInstantMessageChannelEdit(this.props.match.params.instantMessageChannelId);
    }

    componentDidUpdate(prevProps: InstantMessageChannelEditViewProp, prevState: IInstantMessageChannelEditViewState): void {
        if (this.scrollToTop) {
            if (!this.dataContainerDiv.scrollTo) {
                this.dataContainerDiv.scrollTop = 0;
                this.dataContainerDiv.scrollLeft = 0;
            } else {
                this.dataContainerDiv.scrollTo(0, 0);
            }
            this.scrollToTop = false;
        }
    }

    componentWillUnmount(): void {
        this.props.resetInstantMessageChannelEdit();
    }

    // #region General
    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "xts") {
            this.setState({ code: value });
        } else if (name === "comment") {
            this.setState({ comment: value });
        } else if (name === "messageExpirationTime") {
            this.setState({ messageExpirationTime: value.toInteger() });
        }
    };

    handleSetPicture = async (file: File) => {
        if (!file) return;
        const attachment = await FileAttachment.fileToFileAttachment(file, 0);
        if (!attachment) return;
        if (!AppUtils.validateFileAttachment(attachment)) return;
        this.setState({ file: attachment, resetPicture: false, picture: attachment.thumbnail });
    };

    handleRemovePicture = () => {
        this.setState({ file: null, resetPicture: true, picture: "" });
    };

    handleSetArchivingType = (archivingType: number) => {
        const state = this.state;
        const archivingRemoveDate = !EnumHelper.isEqual(InstantMessageChannelArchivingType.RemoveChannel, state.archivingType) &&
            EnumHelper.isEqual(InstantMessageChannelArchivingType.RemoveChannel, archivingType)
            ? state.defaultArchivingRemoveDate
            : state.archivingRemoveDate;
        this.setState({
            archivingType,
            archivingRemoveDate
        });
    };

    checkErrors = (): Promise<boolean> => {
        const state = this.state;
        return new Promise<boolean>((resolve) => {
            if (!state.code) {
                AppUtils.showErrorMessage(Translations.NameMustBeDefined);
                return resolve(false);
            }
            return resolve(true);
        });
    };

    getWarningMessage = (): Promise<string> => {
        return new Promise<string>((resolve) => {
            return resolve("");
        });
    };
    // #endregion General

    // #region Users
    handleUsersRemoved = (ids: string[]) => {
        if (!ids || ids.length < 1) return;
        this.setState({
            channelUsers: this.state.channelUsers.filter(i => ids.indexOf(i.id) < 0)
        });
    };
    
    handleUsersAdded = (companyId: string, newUsers: IUserListItem[], addedUsers: IInstantMessageChannelAddedUser[]) => {
        if (!newUsers || newUsers.length < 1) return;
        const state = this.state;
        const channelUsers = state.channelUsers.slice(0);
        for (const newUser of newUsers) {
            const addedUser = addedUsers.find(i => i.userId === newUser.id);
            if (!addedUser) continue;
            const user = new InstantMessageChannelEditUserItem();
            user.id = addedUser.id;
            user.companyId = companyId;
            user.userType = InstantMessageChannelUserType.User;
            user.userCode = newUser.code;
            user.firstName = newUser.name;
            user.lastName = "";
            user.picture = newUser.picture;
            user.activeState = addedUser.activeState;
            channelUsers.push(user);
        }
        this.setState({
            channelUsers
        });
    };

    handleUserTypeUpdated = async (id: string, userType: number) => {
        const state = this.state;
        const user = state.channelUsers.find(i => i.id === id);
        if (!user) return;
        const newUser = new InstantMessageChannelEditUserItem(user);
        const channelUsers = state.channelUsers.filter(i => i.id !== id);
        newUser.userType = userType;
        channelUsers.push(newUser);
        this.setState({
            channelUsers
        });
    };
    
    handleLoadUsers = async (page: number, companyId: string): Promise<IEndlessList<UserListItem>> => {
        const state = this.state;
        return await AppUtils.callService(() => instantMessageChannelService.instantMessageChannelGetSelectUserListItems(state.companyId, Base.emptyGuid, companyId, page, [this.props.user.userCode]));
    };
    // #endregion Users

    closeView = (): void => {
        const props = this.props;
        const state = this.state;
        const returnUrl = state.id
            ? ("/instantmessage/" + state.id)
            : (props.returnUrl ? props.returnUrl : "/instantmessage");
        customHistory.push(returnUrl);
    };

    static getSaveDataFromState = async (state: IInstantMessageChannelSaveState, overrideCode: string = null): Promise<SaveDataObj> => {
        const result = new SaveDataObj();
        result.append("companyId", state.companyId);
        result.append("id", state.id);
        result.append("rowId", state.rowId);
        result.append("code", overrideCode ?? state.code);
        result.append("comment", state.comment);
        result.append("internalChannel", state.internalChannel);
        result.append("activeState", state.activeState);
        result.append("archivingType", state.archivingType);
        result.append("archivingRemoveDate", EnumHelper.isEqual(InstantMessageChannelArchivingType.RemoveChannel, state.archivingType) ? state.archivingRemoveDate.toDate().getTime() : null);
        result.append("messageExpirationTime", state.messageExpirationTime);
        result.append("resetPicture", state.resetPicture);
        if (state.file) {
            result.append("attachments", await SaveAttachmentBase64.fromFileAttachments([state.file]));
        }
        return result;
    };

    saveInstantMessageChannel = async () => {
        const state = this.state;
        if (!await AppUtils.validate(this.checkErrors, this.getWarningMessage)) return;
        const saveData = await InstantMessageChannelEditView.getSaveDataFromState(state, !state.code ? Translations.NewInstantMessageChannel : null);
        const result = await AppUtils.callService(() => instantMessageChannelService.saveInstantMessageChannelEdit(saveData.obj));
        if (!result) return;
        this.closeView();
    };

    handleSaveClick = () => {
        const obj = this;
        store.customStore.dispatch(storeActions.setConfirmation(storeTypes.ConfirmationDialogType.Information, Translations.SaveInstantMessageChannel, Translations.SaveInstantMessageChannelConfirmation,
            () => {
                store.customStore.dispatch(storeActions.clearConfirmation());
                obj.saveInstantMessageChannel();
            },
            () => {
                store.customStore.dispatch(storeActions.clearConfirmation());
            }));
    };

    handleBackClick = async () => {
        const obj = this;
        const saveData = await InstantMessageChannelEditView.getSaveDataFromState(this.state);
        if (!Base.isNullOrUndefined(saveData) && saveData.hash !== InstantMessageChannelEditView.orgStateHash) {
            store.customStore.dispatch(storeActions.setConfirmation(storeTypes.ConfirmationDialogType.Warning, Translations.Warning, Translations.YouHaveNotSavedChangesDoYouWantToSaveChanges,
                () => {
                    store.customStore.dispatch(storeActions.clearConfirmation());
                    obj.saveInstantMessageChannel();
                },
                () => {
                    store.customStore.dispatch(storeActions.clearConfirmation());
                    obj.closeView();
                },
                () => {
                    store.customStore.dispatch(storeActions.clearConfirmation());
                }));
        } else {
            obj.closeView();
        }
    };

    render() {
        const props = this.props;
        const state = this.state;
        const item = props.item;
        if (item == null) {
            return (
                <div className="pageBackground" style={ { zIndex: 2 } }>
                    <EditPageHeader
                        title={Translations.InstantMessageChannel}
                        onBackClick={this.handleBackClick}
                    />
                </div>
            );
        }
        const isReadOnly = !item.userIsInstantMessageChannelAdmin;
        const hasPartners = item.companies.length > 1;
        const hasExternalUsers = !!state.channelUsers.find(i => i.companyId !== state.companyId);
        const fixedName = InstantMessageChannelHelper.getFixedName(state.channelUsers, props.user.userCode);
        return (
            <div className="pageBackground" style={ { zIndex: 2 } }>
                <EditPageHeader
                    title={(isReadOnly ? Translations.InstantMessageChannel : Translations.EditInstantMessageChannel) + " - " + (fixedName ?? state.code).substr(0, 25)}
                    onBackClick={this.handleBackClick}
                />
                <Footer
                    isReadOnly={isReadOnly}
                    onClick={this.handleSaveClick}
                />
                <div className="pageContentContainer mainEdit instantMessageChannelEdit">
                    <div className="dataContainer" ref={(elem) => { this.dataContainerDiv = elem; }}>
                        {/* Task */ }
                        <div className="sectionTitle">{Translations.BasicInformation}</div>
                        <div className="row">
                            <div className="col-12">
                                <div className="userIconAndCode">
                                    <div className="pictureContainer form-group">
                                        <AvatarImage
                                            classes="large"
                                            id={InstantMessageChannelHelper.getAvatarId(state.channelUsers, state.picture, props.user.userCode)}
                                            name={fixedName ?? state.code}
                                            image={InstantMessageChannelHelper.getPicture(state.channelUsers, state.picture, props.user.userCode)}
                                            imageClass={InstantMessageChannelHelper.getPictureClass(state.channelUsers, state.picture, props.user.userCode)}
                                            editable={!isReadOnly}
                                            tooltip={Translations.CkickToChangeThePicture}
                                            removeTooltip={Translations.RemovePicture}
                                            onChange={this.handleSetPicture}
                                            onError={(message) => { AppUtils.showErrorMessage(message); }}
                                            onLongPress={state.resetPicture ? null : this.handleRemovePicture}
                                            longPressMs={appConfig.longPressMs}
                                        />
                                    </div>
                                    <div className="codeContainer form-group">
                                        <label className="control-label">{Translations.Name}</label>
                                        <input className="form-control" type="text" name="xts" title={Translations.Name} maxLength={50} value={fixedName ?? state.code} readOnly={!!fixedName || isReadOnly} disabled={!!fixedName || isReadOnly} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group required">
                                    <label className="control-label">{Translations.MessagePreservationTime}</label>
                                    <select className="form-control" name="messageExpirationTime" title={Translations.MessagePreservationTime} value={state.messageExpirationTime.toString(10)} disabled={isReadOnly} onChange={this.handleChange}>
                                        {state.messageExpirationTimes.map((messageExpirationTime) =>
                                            <option key={messageExpirationTime.number} value={messageExpirationTime.number.toString(10)}>{messageExpirationTime.title}</option>
                                        )}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label className="control-label">{Translations.Description}</label>
                                    <textarea className="form-control mSize" name="comment" title={Translations.Description} maxLength={500} readOnly={isReadOnly} disabled={isReadOnly} value={state.comment} required={true} onChange={this.handleChange} />
                                </div>
                            </div>
                        </div>
                        {hasPartners &&
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <CheckBox
                                            title={Translations.InstantMessageChannelInternal}
                                            checked={state.internalChannel}
                                            disabled={isReadOnly || !state.internalChannel && hasExternalUsers}
                                            onClickBoolean={(checked: boolean) => {
                                                this.setState({ internalChannel: checked });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <CheckBox
                                        title={Translations.Archived}
                                        checked={state.activeState < 0.5}
                                        disabled={isReadOnly}
                                        onClickBoolean={(checked: boolean) => {
                                            this.setState({
                                                activeState: checked ? 0 : 1,
                                                archivingType: checked ? InstantMessageChannelArchivingType.KeepMessages : InstantMessageChannelArchivingType.None
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        {state.activeState < 0.5 &&
                            <div className="row">
                                <div className="col">
                                    <div className="form-group">
                                        <label className="control-label">{Translations.InstantMessageChannelArchivingType}</label>
                                        <Radio
                                            classes="mt-1"
                                            name="archivingType"
                                            title={Translations.InstantMessageChannelArchivingTypeKeepMessages}
                                            checked={EnumHelper.isEqual(InstantMessageChannelArchivingType.KeepMessages, state.archivingType)}
                                            disabled={isReadOnly}
                                            onClickBoolean={(checked: boolean) => {
                                                this.handleSetArchivingType(checked ? InstantMessageChannelArchivingType.KeepMessages : InstantMessageChannelArchivingType.RemoveChannel);
                                            }}
                                        />
                                        <Radio
                                            name="archivingType"
                                            title={String.format(Translations.InstantMessageChannelArchivingTypeRemoveChannelAtDateParameter, state.archivingRemoveDate)}
                                            checked={EnumHelper.isEqual(InstantMessageChannelArchivingType.RemoveChannel, state.archivingType)}
                                            disabled={isReadOnly}
                                            onClickBoolean={(checked: boolean) => {
                                                this.handleSetArchivingType(checked ? InstantMessageChannelArchivingType.RemoveChannel : InstantMessageChannelArchivingType.KeepMessages);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="sectionTitle">{Translations.InstantMessageChannelUsers}</div>
                        <InstantMessageChannelUserList
                            isReadOnly={isReadOnly}
                            newChannelWizard={false}
                            companies={hasPartners && !state.internalChannel ? item.companies : [item.companies[0]]}
                            user={props.user}
                            instantMessageChannelId={state.id}
                            instantMessageChannelCompanyId={state.companyId}
                            users={state.channelUsers}
                            onRemoved={this.handleUsersRemoved}
                            onAdded={this.handleUsersAdded}
                            onUserTypeUpdated={this.handleUserTypeUpdated}
                        />
                    </div>
                </div>
            </div>
        );
    }
}